import styled from 'styled-components';

export const Wrapper = styled.div`
    flex-grow: 1;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;
